import { Eyebrow, FadeIn } from "./Reveal";

const STATS = [
  { value: "12", label: "Minutes from Westport town" },
  { value: "2", label: "Minute island crossing by RIB" },
  { value: "22", label: "Guests at our private lodge" },
  { value: "8+", label: "Ages welcome on every adventure" },
];

const PROMISES = [
  "We personalise every experience for your group",
  "A magical all-inclusive package, created for your event",
  "Just 2 minutes from the mainland, on our own private island",
  "Safe, seamless and incredibly fun — from start to finish",
];

export default function Welcome() {
  return (
    <section id="welcome" className="relative overflow-hidden bg-navy-800 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-16 lg:grid-cols-2 lg:gap-20">
          <div>
            <Eyebrow>Travel &middot; Discover &middot; Learn</Eyebrow>
            <FadeIn delay={0.1}>
              <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
                There is something <em className="italic text-gold">for everyone</em>
              </h2>
            </FadeIn>
            <FadeIn delay={0.2}>
              <p className="mt-8 text-sm font-light leading-relaxed text-mist sm:text-base">
                Welcome to the adventure of a lifetime! Our capable team takes pride in
                curating unforgettable experiences from start to finish &mdash; a safe,
                seamless and incredibly fun adventure that will leave you with memories to
                cherish for years to come.
              </p>
              <p className="mt-5 text-sm font-light leading-relaxed text-mist sm:text-base">
                Discover your inner adventurer with a tailor-made package of exhilarating
                activities on Collanmore Island, in the heart of Clew Bay beneath Croagh
                Patrick on the Wild Atlantic Way.
              </p>
            </FadeIn>
            <FadeIn delay={0.3}>
              <ul className="mt-10 space-y-4 border-l-2 border-gold/40 pl-6">
                {PROMISES.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm text-ivory/90">
                    <span className="mt-[7px] inline-block h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" />
                    {p}
                  </li>
                ))}
              </ul>
            </FadeIn>
          </div>

          <div className="relative">
            <FadeIn delay={0.15}>
              <div className="relative ml-auto w-full max-w-lg">
                <div className="absolute -right-4 -top-4 h-full w-full border border-gold/40" aria-hidden="true" />
                <img
                  src="/images/clew-bay-aerial.webp"
                  alt="Aerial view over Clew Bay and Croagh Patrick"
                  className="relative aspect-[4/3] w-full object-cover"
                  data-testid="welcome-image-main"
                />
                <img
                  src="/images/kayak-beach.webp"
                  alt="Group of kayakers setting out from the shore of Clew Bay"
                  className="absolute -bottom-10 -left-6 hidden w-2/5 border-4 border-navy-800 object-cover shadow-2xl shadow-navy-950 sm:block sm:w-[46%]"
                  data-testid="welcome-image-inset"
                />
              </div>
            </FadeIn>
          </div>
        </div>

        <FadeIn delay={0.1}>
          <div className="mt-28 grid grid-cols-2 gap-px border border-gold/15 bg-gold/15 lg:grid-cols-4">
            {STATS.map((s, i) => (
              <div key={s.label} data-testid={`stat-${i + 1}`} className="bg-navy-800 p-8 sm:p-10">
                <p className="font-serif text-5xl text-gold sm:text-6xl">{s.value}</p>
                <p className="mt-3 text-[11px] uppercase tracking-[0.2em] text-mist">{s.label}</p>
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
